import { gql } from "lib/apolloClient";

export const bulkUploadStudentWizardDataMutation = gql`
  mutation bulkUploadStudentWizardData($input: StudentWizardDataInput!) {
    platform {
      bulkUploadStudentWizardData(input: $input)
    }
  }
`;
